import {
  generateKey,
  DomainAPI,
  Channel,
  APIKey,
  Authorization,
  _pick
} from "../utils/setting";
import { checkResponse } from "../utils/checkResponse";
const visitors = {
  state: {
    list_visitor: [],
    one_visitor: {},
    new_visitor: {},
    list_fromType: [],
    total: 0,
    count: 0
  },
  reducers: {
    setState(state, payload) {
      state = { ...state, ...payload };
      return { ...state };
    }
  },
  effects: dispatch => ({
    getList(payload = {}, rootState) {
      const _this = this;
      let url = DomainAPI + Channel + "/api/secure/visitors/list";
      if (!payload.search) delete payload.search;
      return fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          [APIKey]: generateKey(),
          [Authorization]: rootState.user.token
        },
        body: JSON.stringify(payload)
      })
        .then(res => res.json())
        .then(res => {
          checkResponse(res);
          const { list, fromType, total, count } = res.data;
          if (res.code && res.data) {
            _this.setState({
              list_visitor: list,
              total: total,
              count: count,
              list_fromType: fromType
            });
          } else {
            if (payload.snackbar) {
              payload.snackbar(res.message || "Something went wrong", "error");
            }
          }
          return res;
        })
        .catch(error => {
          if (payload.snackbar) {
            payload.snackbar(error.message || "Something went wrong", "error");
          }
          return {
            code: 0,
            error: error,
            message: error.message
          };
        });
    },
    update(payload = {}, rootState) {
      const _this = this;
      let url = DomainAPI + Channel + "/api/secure/visitors/update";

      return fetch(url, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          [APIKey]: generateKey(),
          [Authorization]: rootState.user.token
        },
        body: JSON.stringify(
          _pick(payload.visitor, [
            "_id",
            "name",
            "phone",
            "countryCode",
            "email",
            "gender",
            "district",
            "city",
            "address",
            "state",
            "age",
            "userAgent",
            "userAgentInfo",
            "socialId",
            "socialLink",
            "fromType",
            "latitude",
            "longtitude",
            "ip"
          ])
        )
      })
        .then(res => res.json())
        .then(res => {
          checkResponse(res);
          if (res.code && res.data) {
            _this.setState({ one_visitor: res.data });

            if (payload.snackbar) {
              payload.snackbar("Update success", "success");
            }
          } else {
            if (payload.snackbar) {
              payload.snackbar(res.message || "Something went wrong", "error");
            }
          }
          return res;
        })
        .catch(error => {
          if (payload.snackbar) {
            payload.snackbar(error.message || "Something went wrong", "error");
          }
          return {
            code: 0,
            error: error,
            message: error.message
          };
        });
    },
    delete(payload = {}, rootState) {
      const _this = this;
      let url = DomainAPI + Channel + "/api/secure/visitors/delete";

      return fetch(url, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          [APIKey]: generateKey(),
          [Authorization]: rootState.user.token
        },
        body: JSON.stringify({
          _id: payload._id
        })
      })
        .then(res => res.json())
        .then(res => {
          checkResponse(res);
          if (res && res.code) {
            if (payload.snackbar) {
              payload.snackbar("Delete success", "success");
            }
            _this.getList();
          } else {
            if (payload.snackbar) {
              payload.snackbar(res.message || "Something went wrong", "error");
            }
          }
          return res;
        })
        .catch(error => {
          if (payload.snackbar) {
            payload.snackbar(error.message || "Something went wrong", "error");
          }
          return {
            code: 0,
            error: error,
            message: error.message
          };
        });
    },
    createCustomer(payload = {}, rootState) {
      const _this = this;
      let url = DomainAPI + Channel + "/api/secure/visitors/createCustomer";

      return fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          [APIKey]: generateKey(),
          [Authorization]: rootState.user.token
        },
        body: JSON.stringify(payload.visitor)
      })
        .then(res => res.json())
        .then(res => {
          checkResponse(res);
          if (res.code && res.data) {
            if (payload.snackbar) {
              payload.snackbar("Delete success", "success");
            }
            _this.getList();
          } else {
            if (payload.snackbar) {
              payload.snackbar(res.message || "Something went wrong", "error");
            }
          }
          return res;
        })
        .catch(error => {
          if (payload.snackbar) {
            payload.snackbar(error.message || "Something went wrong", "error");
          }
          return {
            code: 0,
            error: error,
            message: error.message
          };
        });
    }
  })
};

export default visitors;
